import React from 'react';
import classnames from 'classnames/bind';

import css from './icon-button.module.scss';

const styles = classnames.bind(css);

const IconButton = ({ className, label, icon: Icon, link, onClick, target, iconAlign = 'right', ...props }) => {
    return (
        <a
            role="button"
            className={styles('button', { 'button--wide': label }, className)}
            onClick={onClick}
            target={target}
            rel="noopener"
            href={link}
            style={{
                flexDirection: iconAlign == 'right' ? 'row' : 'row-reverse',
            }}
            {...props}
        >
            {label && (
                <span className={styles('button__label')}>
                    {label}
                </span>
            )}
            <Icon className={styles('button__icon')} />
        </a>
    );
};

export default IconButton;
